import React from "react";

export const PassTable = (props) => {
  const {passFields} = props;

  return (
    <table className="pass-table">
      <thead>
      <tr>
        <th className='text-center'>Seat</th>
        <th className='text-center'>Weight</th>
        <th className='text-center'>Name</th>
        <th className='text-center'>BookID</th>
        <th width="25%">Note</th>
      </tr>
      </thead>
      <tbody>
        {passFields.map((pass, index) => {
          const { title, weight, bookingId } = pass;
          const [seat, name] = title.split('.');
          const rowClassName = index === 0 ? "pass-table-pilot" : "";
          const weightValue = Number(weight.value).toFixed(2);
          const bookId = bookingId ? (`${bookingId}`).substr(bookingId.length - 4) : '';

          return (
            <tr className={rowClassName} key={title}>
              <td className={""}>{seat + "."}</td>
              <td className='text-left'>{isNaN(weightValue) ? "0.00" : weightValue}</td>
              <td className='text-left'>{name}</td>
              <td className='text-left'>{bookId}</td>
              <td className='text-left'></td>
            </tr>
        )})}
      </tbody>
    </table>
  )}
